<template src="../templates/fecondity.pug" lang="pug"></template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { format, parse } from 'date-fns'
import _filter from 'lodash/filter'
import FilterState from './filter/FilterState'
import FecondityForm from './form/FecondityForm'
import AnimalCard from './card/AnimalCard'
import 'vue-loaders/dist/vue-loaders.css'

export default {
    name: 'Fecondity',
    components: {
        FilterState,
        FecondityForm,
        AnimalCard,
    },
    data() {
        return {
            showAnimalForm: false,
            selectedAnimal: null,
            showFecondityForm: false,
            animalToUpdate: null,
            action: null,
            searchInput: '',
            format
        }
    },
    computed: {
        ...mapGetters([
            'animals',
            'selectedFarm',
            'cattleLoading',
            'countAnimalByType',
            'filteredFecondityAnimals',
            'filterCowTypes',
            'isUserVisitor',
            'isColumnOrdered'
        ]),
        filteredAnimals() {
            if (this.searchInput.length > 0) {
                let self = this
                return _filter(this.animals, function(a) {
                    let str = a.buckleNumber.toString()
                    return str.includes(self.searchInput)
                })
            } else {
                return this.filteredFecondityAnimals
            }
        }
    },
    created() {
        this.$store.commit('resetFilterState')
        this.$store.commit('resetFilterCowType')
        this.$store.commit('resetTableOrder')
    },
    methods: {
        ...mapMutations(['updateFilterCowType', 'resetFilterCowType', 'updateTableOrder']),
        addState(animal, action) {
            this.animalToUpdate = animal
            this.action = action
            this.showFecondityForm = true
        }
    }
}
</script>

<style lang="sass" scoped>
    @import '../sass/mixin/color'
    @import '../sass/mixin/flex'

    #fecondity
        #filters-state
            margin-top: 4px
        table
            .table-header
                background-color: $dd-very-dark-gray
            .cell-buckle-number
                cursor: pointer
                &:hover
                    font-size: 18px
                    font-weight: bold
                    color: $dd-light-orange
</style>
